import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toggleBodyOverlay } from 'ck-utils';
import { Icon, Typography } from 'ck-ui';
import { ResponsiveColumn } from './ResponsiveColumn';
import { NbHits } from './NbHits';
import { Aside } from './Aside';
import styles from './Aside.module.scss';

const AsideToggle = ({ mobileSortBy }) => {
  const [isMobileAsideOpen, setIsMobileAsideOpen] = useState(false);
  const toggleMobileAside = (e) => {
    e.preventDefault();
    toggleBodyOverlay(!isMobileAsideOpen, 'aside');
    setIsMobileAsideOpen(!isMobileAsideOpen);
  };

  return (
    <>
      <div className={styles.toggleRoot}>
        <a className={styles.toggle} href="#" onClick={toggleMobileAside}>
          <Typography display="inline">
            Filter & Sort <NbHits isMobile />
          </Typography>
          <Icon name="filter" size="regular" />
        </a>
        <ResponsiveColumn />
      </div>
      <Aside
        isMobileOpen={isMobileAsideOpen}
        toggleMobileAside={toggleMobileAside}
        mobileSortBy={mobileSortBy}
      />
      {isMobileAsideOpen && (
        <div
          role="presentation"
          className={styles.toggleBlur}
          onClick={toggleMobileAside}
        />
      )}
    </>
  );
};

AsideToggle.propTypes = {
  mobileSortBy: PropTypes.node.isRequired,
};

export { AsideToggle };
